/* eslint-disable global-require */
import React from 'react';
import Router from 'next/router';
import App from 'next/app';
import PropTypes from 'prop-types';
import smoothscroll from 'smoothscroll-polyfill';
import ErrorComponent from './_error';
import './_app.scss';
import { ErrorProvider } from '../src/context/ErrorContext';
import { getFlagSettings } from '../src/components/experiences/Experiences';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}
export class PlpApp extends App {
  componentDidMount() {
    Router.events.on('routeChangeStart', (url) => {
      document.body.dispatchEvent(
        new CustomEvent('routeChangeStart', {
          detail: {
            url,
          },
        })
      );
      document.getElementsByTagName('html')[0].classList.add('loading');
    });

    Router.events.on('routeChangeComplete', (url) => {
      document.body.dispatchEvent(
        new CustomEvent('routeChangeComplete', {
          detail: {
            url,
          },
        })
      );
      document.getElementsByTagName('html')[0].classList.remove('loading');
    });
  }

  componentWillUnmount() {
    Router.events.off('routeChangeStart');
    Router.events.off('routeChangeComplete');
  }

  render() {
    const { Component, pageProps } = this.props;
    const { experiencesConfig } = pageProps;
    const experiences = experiencesConfig
      ? JSON.parse(experiencesConfig)
      : null;
    const { isRemoveTheBeigeFlagOn = false } = getFlagSettings(experiences);

    const { error, errorCode } = pageProps;

    if (error && Component !== ErrorComponent) {
      throw new Error(error);
    }

    if (errorCode) {
      return <ErrorComponent statusCode={errorCode} />;
    }

    return (
      <ErrorProvider>
        <style jsx global>{`
          body {
            background: ${isRemoveTheBeigeFlagOn ? 'white' : '#fbf4e7'};
          }
        `}</style>
        <Component {...pageProps} />
      </ErrorProvider>
    );
  }
}

PlpApp.propTypes = {
  Component: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Array),
  ]).isRequired,
  pageProps: PropTypes.instanceOf(Object),
};

export default PlpApp;
